import React from "react";
import Tab from "@mui/material/Tab";
import { withStyles } from "@mui/styles";

export const tabHeight = "35px"; // default: '48px'

const TabStyle = withStyles((theme) => ({
  root: {
    minHeight: tabHeight,
    height: tabHeight,
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    backgroundColor: theme.palette.primary.main,
    color: "rgba(255, 255, 255, 0.7)",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.5)",
      color: "white",
      opacity: 1,
    },
    "&$selected": {
      backgroundColor:
        theme.palette.type === "dark"
          ? theme.palette.text.primary
          : theme.palette.background.default,
      color: theme.palette.success.main,
      fontWeight: theme.typography.fontWeightMedium,
      borderRightColor:
        theme.palette.type === "dark" ? theme.palette.primary.light : theme.palette.primary.main,
      borderRightWidth: 2,
      borderRightStyle: "solid",
      borderLeftColor:
        theme.palette.type === "dark" ? theme.palette.primary.light : theme.palette.primary.main,
      borderLeftWidth: 2,
      borderLeftStyle: "solid",
      borderTopColor:
        theme.palette.type === "dark" ? theme.palette.primary.light : theme.palette.primary.main,
      borderTopWidth: 2,
      borderTopStyle: "solid",
    },
    borderBottomColor:
      theme.palette.type === "dark" ? theme.palette.primary.light : theme.palette.primary.main,
    borderBottomWidth: 2,
    borderBottomStyle: "solid",
  },
  selected: {},
}))((props) => <Tab {...props} />);

export default TabStyle;
